import { createAction } from "redux-actions";

export const openUserAction = createAction("openUserAction");
export const closeUserAction = createAction("closeUserAction");
export const margeUserAction = createAction("margeUserAction");